import { render, staticRenderFns } from "./EditArticleModal.vue?vue&type=template&id=6b299f27"
import script from "./EditArticleModal.vue?vue&type=script&lang=ts"
export * from "./EditArticleModal.vue?vue&type=script&lang=ts"
import style0 from "./EditArticleModal.vue?vue&type=style&index=0&id=6b299f27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports